import React from "react";

const StatsCard = ({
  title,
  value,
  icon,
  iconColor = "primary",
  trend = null,
  loading = false,
}) => {
  const colorClasses = {
    primary: "bg-primary-subtle text-primary",
    success: "bg-success-subtle text-success",
    info: "bg-info-subtle text-info",
    warning: "bg-warning-subtle text-warning",
    danger: "bg-danger-subtle text-danger",
    secondary: "bg-secondary-subtle text-secondary",
  };

  return (
    <div className="card h-100 border-0 shadow-sm" style={{ transition: "transform 0.2s, box-shadow 0.2s" }}>
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
          {/* Icon */}
          <div 
            className={`rounded-3 d-flex align-items-center justify-content-center ${colorClasses[iconColor]}`}
            style={{ width: "48px", height: "48px" }}
          >
            {loading ? (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <i className={`${icon} fs-5`}></i>
            )}
          </div>

          {/* Trend Badge */}
          {trend && !loading && (
            <span
              className={`badge ${
                trend.isPositive ? "bg-success-subtle text-success" : "bg-danger-subtle text-danger"
              } border-0`}
              style={{ fontSize: "0.7rem", fontWeight: 600 }}
            >
              <i
                className={`fas ${
                  trend.isPositive ? "fa-arrow-up" : "fa-arrow-down"
                } me-1`}
              ></i>
              {trend.percentage}%
            </span>
          )}
        </div>

        {/* Title */}
        <div className="text-muted mb-1" style={{ fontSize: "0.875rem", fontWeight: 500 }}>
          {title}
        </div>

        {/* Value */}
        <div className="fs-3 fw-bold text-dark">
          {loading ? (
            <div className="placeholder-glow">
              <span className="placeholder col-6"></span>
            </div>
          ) : (
            value?.toLocaleString() || "0"
          )}
        </div>

        {trend && !loading && (
          <div className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
            {trend.period}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
